import { errorDev } from './logger';
const CONSENT_KEY = "orrith_cookie_consent_v1";

const DEFAULT_CONSENT = {
  necessary: true,
  preferences: false,
  analytics: false,
  marketing: false,
};

export function readStorageConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return { ...DEFAULT_CONSENT, ...parsed, necessary: true };
  } catch (err) {
    errorDev("Operation failed:", err);
    return null;
  }
}

export function canUsePreferencesStorage() {
  const consent = readStorageConsent();
  if (!consent) return false;
  return Boolean(consent.preferences);
}

export function canUseAnalyticsStorage() {
  const consent = readStorageConsent();
  if (!consent) return false;
  return Boolean(consent.analytics);
}

export function canUseMarketingStorage() {
  const consent = readStorageConsent();
  if (!consent) return false;
  return Boolean(consent.marketing);
}
